import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { PermissionService } from '@services/permission/permission.service';
import { APP_ROUTES } from 'app/constants';
import { Permission } from 'app/enums';

export const firmwareAdministrationGuard = (): boolean | UrlTree => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    return (
        (permissionService.hasPermissions([Permission.WriteFirmware]) && permissionService.isUnrestricted()) ||
        router.createUrlTree([APP_ROUTES.Root])
    );
};
